// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1TmKA","content":"LayoutSettings_content__1rcbz"};